import React from "react";
import Background from "../image/spash_01.jpg";
import Splash02 from "../image/spash_02.jpg";
import "./About.css";

const About = () => {
  return (
    <>
      {/* ==========================================
          ABOUT TEDx
          ========================================== */}
      <section id="about" className="about-modern-section about-tedx">

        <div className="container about-modern-container">

          <div className="row align-items-center g-5">

            {/* Text - Left */}
            <div className="col-lg-6">

              <div className="about-modern-content">

                <span className="about-modern-label">
                  DISCOVER TEDx
                </span>

                <h2 className="about-modern-title">
                  About <span>TEDx</span>
                </h2>

                <h3 className="about-modern-subtitle">
                  Ideas Worth Spreading
                </h3>

                <p className="about-modern-highlight">
                  x = independently organized event
                </p>

                <p className="about-modern-description">
                  In the spirit of discovering and spreading ideas,
                  TEDx is a program of local, self-organized events
                  that bring people together to share a TED-like
                  experience.
                </p>

                <p className="about-modern-description">
                  At a TEDx event, TED Talks video and live speakers
                  combine to spark deep discussion and connection.
                </p>

                <p className="about-modern-description">
                  These local, self-organized events are branded TEDx,
                  where x = independently organized TED event.
                  The TED Conference provides general guidance for
                  the TEDx program, but individual TEDx events are
                  self-organized.
                  <em> (Subject to certain rules and regulations.)</em>
                </p>

              </div>

            </div>

            {/* Image - Right */}
            <div className="col-lg-6">

              <div className="about-modern-image-wrapper">

                <img
                  src={Background}
                  alt="TEDx audience and speaker"
                  className="about-modern-image"
                />

                <div className="about-modern-image-accent"></div>

              </div>

            </div>

          </div>

        </div>

      </section>


      {/* ==========================================
          ABOUT TEDxSETAPAK
          ========================================== */}
      <section className="about-modern-section about-setapak">

        <div className="container about-modern-container">

          <div className="row align-items-center g-5">

            {/* Image - Left */}
            <div className="col-lg-6 order-2 order-lg-1">

              <div className="about-modern-image-wrapper">

                <img
                  src={Splash02}
                  alt="TEDxSetapak audience"
                  className="about-modern-image"
                />

                <div className="about-modern-image-accent"></div>

              </div>

            </div>

            {/* Text - Right */}
            <div className="col-lg-6 order-1 order-lg-2">

              <div className="about-modern-content">

                <span className="about-modern-label">
                  OUR COMMUNITY
                </span>

                <h2 className="about-modern-title">
                  What is <span>TEDxSetapak?</span>
                </h2>

                <h3 className="about-modern-subtitle">
                  Where Ideas Change Everything
                </h3>

                <p className="about-modern-description">
                  TEDxSetapak represents our community's contribution
                  to the global movement where{" "}
                  <em>Ideas Change Everything</em>.
                </p>

                <p className="about-modern-description">
                  We bring together diverse speakers and perspectives
                  to spark conversations, inspire action, and create
                  meaningful change.
                </p>

              </div>

            </div>

          </div>

        </div>

      </section>
    </>
  );
};

export default About;